import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-feature-pricing',
  templateUrl: './feature-pricing.component.html',
  styleUrls: ['./feature-pricing.component.css']
})
export class FeaturePricingComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
